import { render, staticRenderFns } from "./RateManagerSuggestionTable.vue?vue&type=template&id=16a12e2d&scoped=true&"
import script from "./RateManagerSuggestionTable.vue?vue&type=script&lang=js&"
export * from "./RateManagerSuggestionTable.vue?vue&type=script&lang=js&"
import style0 from "./RateManagerSuggestionTable.vue?vue&type=style&index=0&id=16a12e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a12e2d",
  null
  
)

export default component.exports